import styled from 'styled-components'

const ReadonlyImageTextTime = styled.p`
  font-size: ${p => p.theme.fonts.$s};
  font-style: italic;
`

ReadonlyImageTextTime.displayName = 'ReadonlyImageTextTime'
export default ReadonlyImageTextTime
